<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="wrapper">
                <div
                    class="container"
                    :class="[!showUserList ? 'small' : '', showUserList ? 'select-users' : '']"
                >
                    <div class="body">
                        <div class="body__title">
                            <h1 class="body__title-text">Oferta {{ offerStatusName }}</h1>
                        </div>
                        <div class="body__description w-100">
                            <p class="body__description-text">Selecione os usuários na lista abaixo:</p>
                        </div>
                    </div>
                    <div class="actions w-100">
                        <div class="row column align-center w-100">
                            <GenericMultiselect
                                class="email-multiselect"
                                :customClass="'mt-0'"
                                ref="users"
                                :options="userOptions"
                                :placeholder="'Usuários'"
                                :fullWidth="true"
                                :searchable="true"
                                :needType="true"
                                :type="'user'"
                                :clearOnOpen="false"
                                :multiple="true"
                                @changeInput="changeInput"
                            />
                            <button
                                id="action-btn"
                                class="actions__btn outline w-100"
                                @click="sendSelectedUsers()"
                            >
                                Enviar
                            </button>
                            <button id="action-btn" class="actions__btn w-100" @click="handleAlertModal()">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import CloseIcon from '@/components/shared/Icons/CloseIcon.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';

export default {
    name: 'AlertModal',
    components: { CloseIcon, SpinnerIcon, GenericMultiselect },
    props: {
        offerStatusName: {
            type: String,
            required: true,
        },
        isWeb: {
            required: true,
        },
    },
    data: () => ({
        showUserList: false,
        selectedUsers: [],
        checked: false,
    }),
    mounted() {},
    methods: {
        setSelectedUsers(users) {
            this.$emit('setSelectedUsers', users);
        },
        handleAlertModal() {
            this.showUserList = false;
            this.$emit('handleAlertModal');
        },
        sendSelectedUsers() {
            try {
                if (this.selectedUsers.length) {
                    this.setSelectedUsers(this.selectedUsers);
                    this.showUserList = false;
                    this.selectedUsers = [];
                    this.handleAlertModal();
                    return;
                }
                throw new Error();
            } catch {
                this.$toastr.e('Selecione ao menos um usuário.');
            }
        },
        changeInput(param) {
            this.selectedUsers = param.value;
        },
    },
    computed: {
        ...mapGetters('offerManagement', ['isLoadingOffers', 'offerEmailUsers']),
        userOptions() {
            let options = this.offerEmailUsers != undefined ? this.offerEmailUsers : [];

            options = options.map((item) => ({
                id: item.id,
                name: `${item.firstName} ${item.lastName}`,
            }));

            return !options.length ? [] : options;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'AlertModal.scss';
</style>